<template>
  <!DOCTYPE html>
  <html class="no-js" lang="en">
  <head>
    <!-- Meta Tags -->
    <meta charset="utf-8">
    <meta http-equiv="x-ua-compatible" content="ie=edge">
    <meta name="viewport" content="width=device-width, initial-scale=1">
    <meta name="author" content="ThemeMarch">
    <!-- Site Title -->
    <title>{{ $t('Order Details') }} #{{ orderDetails.id }}</title>
  </head>
  <body>
    <div class="cs-container">
      <div class="cs-invoice cs-style1">
        <div class="cs-invoice_in" id="download_section">
          <h6 style="display: flex;justify-content:center">{{ $t('Retail Invoice') }}</h6>
          <div class="cs-invoice_head cs-type1 cs-mb25" style="align-items: center;">
            <div class="cs-invoice_left" style="width: 50%;">
              <b class="cs-primary_color cs-f17">{{ orderDetails?.restaurant?.name }}</b>

            </div>
            <div class="cs-invoice_right cs-text_right_modified" style="width: 100%">
              <div class="cs-logo cs-mb5 "><img class="img_size"
                  :src="config.s3_storage_url + 'media/foodapp/original/' + settingData.app_logo" alt="Logo"
                  @error="imageErrorHandle"></div>
            </div>
          </div>
          <div class="cs-mb5">
            <div class="">
              <b class="cs-primary_color">GST No:</b> <span class="cs-mb8">{{ settingData.gst_number }}</span>
            </div>

            <div class="cs-mt15">
              <p>{{ orderDetails?.restaurant?.address }}<br /></p>

              <p class="cs-invoice_number cs-primary_color cs-mb0 cs-f16"><b class="cs-primary_color">Order No:</b>
                #{{ orderDetails?.id }}</p>
            </div>

          </div>
          <div class="restaurant_details">
            <p><b class="cs-primary_color cs-semi_bold">Place Order Date:</b>
              <br>{{ convertTime(orderDetails.created_at) }}</p>

            <p
              v-if="orderDetails?.future_delivery_date && orderDetails.future_delivery_date != '' && orderDetails.future_delivery_date != null && orderDetails.future_delivery_date != '0000-00-00 00:00:00'">
              <b class="cs-primary_color cs-semi_bold">Schedule Order Date:</b>
              <br>{{ convertTime(orderDetails.future_delivery_date) }}</p>

            <p
              v-if="orderDetails?.delivered_date != '' && orderDetails?.delivered_date != null && orderDetails?.delivered_date != '0000-00-00 00:00:00'">
              <b class="cs-primary_color cs-semi_bold">Delivered Order Date:</b>
              <br>{{ convertTime(orderDetails.delivered_date) }}</p>
          </div>
          <div class="cs-heading cs-style1 cs-f18 cs-primary_color cs-mb25 cs-semi_bold">Customer Information</div>
          <ul class="cs-grid_row cs-col_3 cs-mb5">
            <li>
              <p class="cs-mb20">
                <b class="cs-primary_color">Customer Name:</b><br>
                <span class="cs-primary_color">
                  {{ orderDetails?.user?.user_name }} {{ orderDetails?.user?.last_name }}
                </span>
              </p>
              <p class="cs-mb20">
                <b class="cs-primary_color">Customer Number:</b><br>
                <span class="cs-primary_color">
                  {{ orderDetails?.user?.mobile_number }}
                </span>
              </p>
            </li>
            <li>
            </li>
            <li>
              <p class="cs-mb20"><b class="cs-primary_color">Delivery Address:</b> <br><span
                class="cs-primary_color">{{ orderDetails?.locality }} {{ orderDetails?.shipping_address }}</span></p>
              </li>
          </ul>
          <div class="cs-table cs-style2">
            <div class="cs-round_border">
              <div>
                <table>
                  <thead>
                    <tr class="cs-focus_bg">
                      <th class="cs-width_8 cs-semi_bold cs-primary_color">Items</th>
                      <th class="cs-width_2 cs-semi_bold cs-primary_color cs-text_right">Total Price</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item, index) in orderDetails.order_item" :key="index">
                      <td class="cs-width_8"><span class="cs-primary_color">{{ item.quantity }}x </span>
                        {{ item?.menu_item?.item_name ?? '' }} </span> {{ getName(item.menu_item_selections) }}</td>
                      <td class="cs-width_2 cs-text_right cs-primary_color"><span>{{ currency }}</span>
                        {{ item.amount}} </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <div class="cs-table cs-style2">
            <div>
              <table>
                <tbody>
                  <tr class="cs-table_baseline">
                    <td class="cs-width_2 cs-text_left" style="padding-left: 2px; padding-right: 5px;">
                      <p class="cs-primary_color cs-mb0">
                        <b>Pay By</b><br />
                        <span>Cash On Delivery</span>
                      </p>
                    </td>
                    <td class="cs-width_7 cs-text_right" style="padding-right: 0px;">
                      <p class="cs-mb5 cs-mb5 cs-f13 cs-primary_color cs-semi_bold">{{ $t('Sub Total') }}:</p>
                      <p class="cs-mb5 cs-mb5 cs-f13 cs-primary_color cs-semi_bold">{{ $t('CGST') }}
                        ({{ orderDetails?.cgst_percentage }} %):</p>
                      <p class="cs-mb5 cs-mb5 cs-f13 cs-primary_color cs-semi_bold">{{ $t('SGST') }}
                        ({{ orderDetails?.sgst_percentage }} %):</p>
                      <p class="cs-mb5 cs-mb5 cs-f13 cs-primary_color cs-semi_bold">{{ $t('Packaging Charges') }}:</p>
                      <template v-for="(o,i)  in orderDetails.reddemed_coupon">
                        <p class="cs-mb5 cs-mb5 cs-f13 cs-primary_color cs-semi_bold" style="color: red"
                          :key="i" v-if="o?.coupon && (![5, 6, 7].includes(o?.coupon.is_flat_discount)) && o.promocode_discount_price > 0">
                          <span class="text-right text-danger">{{ $t('Discount') }}{{ `(${o.coupon.coupon_code})` }}</span>:
                        </p>
                        <p class="cs-mb5 cs-mb5 cs-f13 cs-primary_color cs-semi_bold" style="color: green"
                          :key="i" v-if="o?.coupon && (![5, 6, 7].includes(o?.coupon.is_flat_discount)) && o.cashback > 0">
                          <span class="text-right text-success">{{ $t('Cashback') }}{{ `(${o.coupon.coupon_code})` }}</span>:
                        </p>
                      </template>
                      <p class="cs-mb5 cs-mb5 cs-f13 cs-primary_color cs-semi_bold">{{ $t('Service Tax') }}:</p>
                      <p class="cs-mb5 cs-mb5 cs-f13 cs-primary_color cs-semi_bold">{{ $t('Delivery Fees') }}:</p>

                      

                      <p class="cs-mb5 cs-mb5 cs-f13 cs-primary_color cs-semi_bold" style="color: green"
                        v-if="orderDetails?.reddemed_coupon_order && orderDetails?.reddemed_coupon_order?.cashback && orderDetails?.reddemed_coupon_order?.cashback > 0">
                        <span class="text-right text-danger">{{ $t('Cashback') }}</span>:</p>
                      <p class="cs-primary_color cs-bold cs-f16 cs-m0">{{ $t('Total Amount') }}:</p>

                    </td>

                    <td class="cs-width_2 cs-text_rightcs-f16 cs-invoice-last-col" style="padding-right: 9px;">
                      <p class="cs-mb5 cs-mb5 cs-text_right cs-f13 cs-primary_color cs-semi_bold"><span>{{ currency
                          }}</span> {{ convertPrice(orderDetails?.sub_total) ?? 0 }}</p>
                      <p class="cs-mb5 cs-mb5 cs-text_right cs-f13 cs-primary_color cs-semi_bold"><span>{{ currency
                          }}</span> {{ convertPrice(orderDetails?.CGST) ?? 0 }}</p>
                      <p class="cs-mb5 cs-mb5 cs-text_right cs-f13 cs-primary_color cs-semi_bold"><span>{{ currency
                          }}</span> {{ convertPrice(orderDetails?.SGST) ?? 0 }}</p>
                      <p class="cs-mb5 cs-mb5 cs-text_right cs-f13 cs-primary_color cs-semi_bold"><span>{{ currency
                          }}</span> {{ convertPrice(orderDetails?.total_packaging_charge) ?? 0 }}</p>
                          <template v-for="(o,i)  in orderDetails.reddemed_coupon">
                      <p class="cs-mb5 cs-mb5 cs-text_right cs-f13 cs-primary_color cs-semi_bold" style="color: red"
                        :key="i"
                        v-if="o?.coupon && (![5, 6, 7].includes(o.coupon.is_flat_discount)) && o.promocode_discount_price > 0">
                        <span class="text-danger">{{ currency }}</span>
                        <span class="text-danger" v-if="o.promocode_discount_price && o.promocode_discount_price <=0 ">{{ (convertPrice(o?.original_price)
                          - convertPrice(o?.discount_price)) ?? 0}}</span>
                        <span class="text-danger" v-else>{{ convertPrice(o?.promocode_discount_price)}}</span>

                      </p>
                      
                      <p class="cs-mb5 cs-mb5 cs-text_right cs-f13 cs-primary_color cs-semi_bold" style="color: green"
                        :key="i"
                        v-if="o?.coupon && (![5, 6, 7].includes(o.coupon.is_flat_discount)) && o.cashback > 0">
                        <span class="text-cashback">{{ currency }}</span>
                        <span class="text-cashback" v-if="o.cashback && o.cashback > 0 ">{{ convertPrice(o?.cashback)}}</span>
                      </p>

                    </template>
                      <p class="cs-mb5 cs-mb5 cs-text_right cs-f13 cs-primary_color cs-semi_bold"><span>{{ currency
                          }}</span> {{ convertPrice(orderDetails?.service_fee) ?? 0 }}</p>
                      <p class="cs-mb5 cs-mb5 cs-text_right cs-f13 cs-primary_color cs-semi_bold"><span>{{ currency
                          }}</span> {{ convertPrice(orderDetails?.delivery_fee) ?? 0 }}</p>




                      <p class="cs-mb5 cs-mb5 cs-text_right cs-f13 cs-primary_color cs-semi_bold" style="color: green"
                        v-if="orderDetails?.reddemed_coupon_order && orderDetails?.reddemed_coupon_order?.cashback && orderDetails.reddemed_coupon_order?.cashback > 0">
                        <span class="text-danger">{{ currency }}</span>
                        <span class="text-danger">{{ convertPrice(orderDetails?.reddemed_coupon_order?.cashback) ?? 0
                          }}</span>
                      </p>
                      <p class="cs-primary_color cs-bold cs-f16 cs-m0 cs-text_right"><span>{{ currency }}</span>
                        {{ convertPrice(orderDetails?.total_amount) ?? 0 }}</p>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </body>
  </html>
</template>
<script>
import { mapActions } from "vuex";
import "../assets/css/invoice.css";
import config from "../config";
import moment from "moment";
import "moment-timezone";
import { imageErrorHandle } from "../helper/helper";

export default {
  data() {
    return {
      config: config,
      orderDetails: {},
      settingData: {},
      imageErrorHandle: imageErrorHandle,
      moment: moment,
      decimal: 2,
      currency: "",
    };
  },
  mounted() {
    this.getOrderDetails();
  },
  methods: {
    ...mapActions("order", ["getInvouceData"]),
    convertTime(date) {
      var formattedData = moment(date).tz(this.settingData.timezone);
      return moment(formattedData).format("YYYY-MM-DD hh:mm A");
    },
    couponName(orderDetails) {
      if (orderDetails?.reddemed_coupon_order?.coupon) {
        return (
          "(" + orderDetails.reddemed_coupon_order?.coupon?.coupon_code + ")"
        );
      } else {
        return "";
      }
    },
    convertPrice(price) {
      return parseFloat(Number(price).toFixed(this.decimal)) ?? 0;
    },
    computeItemPrice(itemDetails) {
      return itemDetails.length > 0
        ? itemDetails.reduce(
            (accu, item) => accu + parseFloat(item.selection_price),
            0
          )
        : 0.0;
    },
    getName(itemDetails) {
      return itemDetails.length > 0
        ? itemDetails
            .reduce((accu, item) => {
              return accu.concat(
                `${item.selection_name} x ${this.convertPrice(
                  item.selection_price
                )}`
              );
            }, [])
            .join(", ")
        : "";
    },
    getOrderDetails() {
      var order_id = atob(this.$route.params.order_id) + "," + config.vendor_id;
      order_id = btoa(order_id);
      this.getInvouceData({
        order_id: order_id,
      }).then((data) => {
        if (data.code == 200) {
          this.orderDetails = data?.Result?.order ?? {};
          this.settingData = data?.Result?.setting ?? {};
          this.decimal = this.settingData.decimal ?? 2;
          this.currency =
            this.settingData.currency === "&#x20B9;" ||
            this.settingData.currency === "&#8377;"
              ? "₹"
              : "$";
        }
      });
    },
  },
};
</script>
